import { propPanelMixin } from './propPanelMixin';
export const designToolMixin = {
  mixins: [propPanelMixin],
  props: {
    isHovering: {
      type: Boolean,
      default: false
    }
  }
};